import React from 'react';
import { Check } from 'lucide-react';

const HorizontalStepper = ({ steps, currentStep, onStepClick, progressPercentage }) => {
  const getStepStatus = (step) => {
    if (step.completed) return 'completed';
    if (step.current) return 'current';
    return 'upcoming';
  };

  const getStepColor = (status) => {
    switch (status) {
      case 'completed': return 'bg-red-600 text-white shadow-sm';
      case 'current': return 'bg-red-600 text-white shadow-sm';
      default: return 'bg-gray-200 text-gray-500';
    }
  };

  return (
    <div className="bg-white rounded-2xl shadow-sm border mx-4 sm:mx-6 p-4 sm:p-6">
      <div>
        {/* Progress Bar */}
        <div className="mb-4 sm:mb-6">
          <div className="flex items-center justify-between mb-2 gap-2">
            <h2 className="text-base sm:text-2xl font-bold text-gray-900 truncate">Offboarding Progress</h2>
            <span className="text-xs sm:text-sm text-gray-600 font-medium flex-shrink-0">{progressPercentage}% Complete</span>
          </div>
          <div className="w-full bg-gray-200 rounded-full h-2">
            <div
              className="bg-gradient-to-r from-red-500 to-red-600 h-2 rounded-full transition-all duration-500 ease-out"
              style={{ width: `${progressPercentage}%` }}
            />
          </div>
        </div>

        {/* Stepper */}
        <div className="relative">
          <div className="flex items-center justify-between">
            {steps.map((step, index) => {
              const Icon = step.icon;
              const status = getStepStatus(step);
              const isLast = index === steps.length - 1;
              const colorClass = getStepColor(status);

              return (
                <React.Fragment key={step.id}>
                  <div className="flex flex-col items-center flex-1">
                    {/* Step Circle */}
                    <button
                      onClick={() => onStepClick(step)}
                      className={`relative w-10 h-10 rounded-full flex items-center justify-center transition-all duration-200 hover:scale-105 ${colorClass} focus-visible:ring-2 focus-visible:ring-red-500 focus-visible:outline-none`}
                      title={step.description}
                    >
                      {step.completed ? (
                        <Check className="w-5 h-5" />
                      ) : (
                        <Icon className="w-5 h-5" />
                      )}
                      {step.current && (
                        <div className="absolute -top-1 -right-1 w-4 h-4 bg-red-600 rounded-full animate-pulse" />
                      )}
                    </button>

                    {/* Step Label */}
                    <div className="mt-3 text-center min-h-[3rem] flex flex-col justify-start">
                      <div className={`text-xs ${step.completed || step.current ? 'text-red-600 font-medium' : 'text-gray-500'}`}>
                        Step {step.id}
                      </div>
                      <div className={`text-sm font-semibold mt-1 leading-tight ${step.completed || step.current ? 'text-red-600 font-medium' : 'text-gray-500'}`}>
                        {step.name}
                      </div>
                    </div>
                  </div>

                  {/* Connector Line */}
                  {!isLast && (
                    <div className={`flex-1 h-1 rounded-full mx-4 mt-[-1.5rem] transition-all duration-200 ${
                      step.completed ? 'bg-red-600' : 'bg-gray-200'
                    }`} />
                  )}
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
};

export default HorizontalStepper;